module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hidden) ? _c('div', {
    staticClass: "clickFullscreenOverlay",
    on: {
      "click": _vm.fullscreen
    }
  }, [_c('div', {
    staticClass: "iconContainer"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('clickFullscreen')) + " "), _c('i', {
    staticClass: "fa fa-expand"
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ca1a3132!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/ClickFullscreen.vue
// module id = 172
// module chunks = 0